import React from 'react';
import {
  Button,
  IconCalendarFilled,
  IconClockFilled,
  IconLocationFilled,
  IconMotorcycle,
  IconPercent,
  IconSettingsFilled,
} from 'takeat-design-system-ui-kit';
import { GiFullMotorcycleHelmet } from 'react-icons/gi';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { NavBar } from './styles';

export const DeliveryNavBar = ({}) => {
  const history = useHistory();
  const thisPath = window.location.pathname.split('/delivery')[1];
  const windowWidth = window.innerWidth;

  return (
    <NavBar>
      <Button
        icon={<IconMotorcycle />}
        variant={thisPath === '/orders' ? 'default' : 'outlined'}
        onClick={() => history.push('/delivery/orders')}
      >
        {' '}
        Delivery
      </Button>

      <Button
        icon={<GiFullMotorcycleHelmet />}
        variant={thisPath === '/motoboys' ? 'default' : 'outlined'}
        onClick={() => history.push('/delivery/motoboys')}
      >
        Motoboys
      </Button>
      <Button
        icon={<IconLocationFilled />}
        variant={thisPath === '/addresses' ? 'default' : 'outlined'}
        onClick={() => history.push('/delivery/addresses')}
      >
        Endereços
      </Button>

      <Button
        icon={<IconClockFilled />}
        variant={thisPath === '/opening-hours' ? 'default' : 'outlined'}
        onClick={() => history.push('/delivery/opening-hours')}
      >
        {windowWidth >= 1105 && 'Funcionamento'}
      </Button>

      <Button
        icon={<IconCalendarFilled />}
        variant={thisPath === '/scheduling' ? 'default' : 'outlined'}
        onClick={() => history.push('/delivery/scheduling')}
      >
        {windowWidth >= 1230 && 'Agendamento'}
      </Button>

      <Button
        icon={<IconPercent />}
        variant={thisPath === '/coupons' ? 'default' : 'outlined'}
        onClick={() => history.push('/delivery/coupons')}
      >
        {windowWidth >= 1305 && 'Cupons'}
      </Button>

      <Button
        icon={<IconSettingsFilled />}
        variant={thisPath === '/config' ? 'default' : 'outlined'}
        onClick={() => history.push('/delivery/config')}
      >
        {windowWidth >= 1375 && 'Config.'}
      </Button>
    </NavBar>
  );
};
